<template>
    <!--
        Angeheftete Warenkorb-Leiste für den Shop ALS EIGENE SEITE.

        Im iframe wird sie nicht gerendert — dort scrollt das iframe-Dokument
        nicht, `position: fixed` bezieht sich auf die iframe-Box, und die
        Leiste läge außerhalb des Blickfelds. Eingebettet rendert sie die
        einbettende Seite (embed.js), gespeist über helper/embedBridge.js.
        TicketList entscheidet anhand von isEmbedded(), wer rendert.
    -->
    <div v-if="amount > 0" class="festiware-cart-spacer" aria-hidden="true"></div>
    <transition name="festiware-cart">
        <div v-if="amount > 0" class="festiware-cart">
            <div class="festiware-cart-inner">
                <span class="festiware-cart-summary">
                    <i class="festiware-cart-icon" uk-icon="cart"></i>
                    <span class="festiware-cart-label">{{ label }}</span>
                </span>
                <button
                    class="uk-button uk-button-primary festiware-cart-next"
                    type="button"
                    @click="$emit('next')"
                >
                    {{ nextLabel }}
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
/**
 * Das Aussehen liegt in
 * plugins/kosmoskosmos/festiware/assets/styles/ticketshop/_cart.scss und
 * kommt über den Theme-Build in die kombinierte CSS der Instanz.
 *
 * @gotcha Nach Änderungen dort muss die kombinierte CSS der Instanz neu
 *   gebaut werden (`festiware:update-css` bzw. themes/<theme>/assets/combined/
 *   <instance>.css löschen) — sonst bleibt die Leiste auf der Instanz
 *   ungestylt. Die von Parcel aus SFC-Styles gebaute assets/styles/
 *   ticketshop.css lädt kein Theme, taugt also nicht als Ablage.
 *
 * Eingebettet rendert die Leiste die einbettende Seite (embed.js), die ihr
 * eigenes CSS mitbringt; TicketList entscheidet anhand von isEmbedded().
 */
export default {
    props: {
        /** Stückzahl über alle gewählten Tickets, nicht Anzahl der Ticketarten */
        amount: {type: Number, required: true},
        /** Fertiger Text, z.B. "3 Tickets für 597,00 €" — kommt aus TicketList,
         *  damit eingebettet und standalone dieselbe Zeile steht. */
        label: {type: String, required: true},
        nextLabel: {type: String, required: true},
    },
    emits: ['next'],
}
</script>
